'use strict';

var ChartDashboardPerformanceDirective = function ChartDashboardPerformanceDirective(Chart) {
  return {
    restrict: 'E',
    template: require('../templates/chart-dashboard-performance.html'),
    controller: 'ChartDashboardPerformanceController',
    scope: {
      screen: '@',
      mode: '@',
      screenState: '=',
      selectedMonths: '=?'
    },
    link: function link($scope, element) {
      var chartElement = element.find('.chart-container');
      var chart = new Chart(chartElement, $scope.chartFormatters);
      $scope.renderChartDataPresent = function (data) {
        chart.changeMetrics($scope.metrics, $scope.screenState.selectedMetric && $scope.screenState.selectedMetric.label);
        chart.render(data);
      };
      $scope.$watch('screenState.dataRepresentation', function () {
        $scope.onDataRepresentationChange($scope.screenState.dataRepresentation);
      });
      $scope.$watch('screenState.aggregationMode', function () {
        $scope.reloadChart();
      });
      $scope.resetBrush = function () {
        chart.resetBrushSelection();
      };
      $scope.clearBrush = function () {
        chart.clearBrush();
      };
      chart.on('rangechange', $scope.rangeChangeHandler);
      $scope.$on('context-menu:dashboard-market-performance:market-analysis', function () {
        $scope.navigateToMarketAnalysis();
      });
      $scope.$on('context-menu:dashboard-market-performance:flight-analysis', function () {
        $scope.navigateToFlightAnalysis();
      });
      $scope.getBrushSelection = function () {
        return chart.getBrushSelection();
      };
      $scope.$on('brush-filter:filterApplied', function (event) {
        if (!event.stopPropagation) {
          $scope.reloadChart();
        }
      });
      $scope.$on('search-criteria:searchChangeEvent', function () {
        $scope.setDefaultSelectedMetric();
        $scope.clearBrush();
      });
      $scope.$on($scope.screen + '-' + $scope.mode + ':dimensionChanged', $scope.reloadChart);
    }
  };
};
ChartDashboardPerformanceDirective.$inject = ['ChartDashboardPerformance', '$rootScope'];
module.exports = ChartDashboardPerformanceDirective;